import SimpleArtist from "@common/types/artist/simple-artist";

interface BeaconIdentityPayload {
  userId: string;
  artistName: string;
  email: string;
  artists?: SimpleArtist[];
  doj: string;
  location?: string;
  paymentEmail?: string;
  organization?: string;
  name?: string
}

const initialBeaconPayload: BeaconIdentityPayload = {
  userId: '',
  artistName: '',
  email: '',
  artists: [],
  doj: '',
  location: '',
  paymentEmail: '',
  organization: '',
  name: ''
};


export const setBeaconIdentity = (data: BeaconIdentityPayload) => {
  window.Beacon('identify', data);
};

export const resetBeaconIdentity = () => {
  window.Beacon('identify', initialBeaconPayload);
};
